import trackFavoritesList, { TrackFavoritesListAction } from './track-favorites-list';

export { trackFavoritesList, TrackFavoritesListAction };

export default trackFavoritesList;
